<template>
  <div class="v-close-view" @click="closeView">
    <slot></slot>
  </div>
</template>

<script>
  function getAppType() {
    let ua = navigator.userAgent.toLowerCase();
    let appType = {
      isJdApp: ua.indexOf("jdapp") > -1 || false,
      isJrApp: ua.indexOf("jdjr") > -1 || ua.indexOf("android-async-http") > -1 || false
    };
    return appType;
  }
  
  function getSystemType() {
    let systemType = {
      isAndroid: /android/i.test(navigator.userAgent),
      isIos: /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    };
    return systemType;
  }
  
  export default {
    methods: {
      closeView() {
        const systemType = getSystemType();
        const appType = getAppType();
        if (appType.isJrApp) {
//          针对老桥//m.jr.jd.com/crayfish/zui/bridge/1.0.7/bridge.js
//          window.jsBridgeV3.onReady().then(function () {
//            this.jsToNaClose();
//          });
          
          window.JrBridge.closeView();
        } else if (appType.isJdApp) {
          if (systemType.isAndroid) {
            window.JSControlHelper&& JSControlHelper.finishActivity();
          } else if (systemType.isIos) {
            window.location.href = "closeJDApp://webview?refresh=true";
          }
        }
      }
    }
  };
</script>